export default "__VITE_ASSET__2f704bba__"